import React, { forwardRef, ReactElement } from 'react';
import { useMergeRefs } from '@floating-ui/react';

import { Comp } from '@redsift/design-system';
import { useTooltipContext } from '../tooltip';
import { TooltipTriggerProps } from './types';
import classNames from 'classnames';

const COMPONENT_NAME = 'TooltipTrigger';
const CLASSNAME = 'redsift-tooltip-trigger';

/**
 * The TooltipTrigger component.
 */
export const TooltipTrigger: Comp<TooltipTriggerProps, HTMLSpanElement> = forwardRef((props, ref) => {
  const { children } = props;

  const { getReferenceProps, refs, tooltipId, triggerClassName, color } = useTooltipContext();
  const childrenRef = (children as any).ref;
  const triggerRef = useMergeRefs([refs.setReference, ref, childrenRef]);

  if (React.isValidElement(children)) {
    return React.cloneElement(children as ReactElement, {
      ...getReferenceProps({
        ref: triggerRef,
        ...props,
        'aria-describedby': tooltipId,
        ...children.props,
        children: children.props.children ?? '',
      }),
      className: classNames((children as ReactElement).props.className, triggerClassName),
      color: color ?? children.props.color,
    });
  }

  return (
    <span ref={triggerRef} {...getReferenceProps(props)}>
      {children}
    </span>
  );
});
TooltipTrigger.className = CLASSNAME;
TooltipTrigger.displayName = COMPONENT_NAME;
